import React from 'react';
import { Messages } from '../../codegen/Localize';
import { EmailAndDisplayNameForm } from './EmailAndDisplayNameForm';
import { ISiteUserInfo } from '../../ts/models/ISiteUserInfo';
import { IServerUserInfo } from '../../ts/models/IServerUserInfo';
import { FeatureFlags } from '../../ts/FeatureFlags';
import { UserSettingsStyle } from '../styles/UserSettingsStyle';
import { ChangePassword, ChangePasswordProps } from './ChangePassword';

export interface GeneralAuthSettingsProps {
  //auth families
  isDomainFamilyLocal: boolean;
  isDomainFamilyExternal: boolean;
  isDomainFamilyAD: boolean;
  //data
  emailFormInitialValues: EmailAndDisplayNameForm.FormFields;
  //meta data realted to business logic
  updateDisplayNameAllowed: boolean;
  siteUser: ISiteUserInfo;
  serverUser: IServerUserInfo;
  isViewerServerAdmin: boolean;
  isViewerSelf: boolean;
  isUserSelf: boolean;
  changePasswordUrl: string;
}

function getHeader(){
  if(FeatureFlags.userSettingMigration){
    return (<h2 className={UserSettingsStyle.titleText}>{Messages.userSettings_Account_Header()}</h2>);
  }
  return null;
}

export function GeneralAuthSettings({emailFormInitialValues, ...passThroughProps}: GeneralAuthSettingsProps) {
  const emailAndDisplayNameFormProps: EmailAndDisplayNameForm.Props = {
    initialValues: emailFormInitialValues,
    ...passThroughProps,
    handleSubmit: EmailAndDisplayNameForm.handleSubmit
  };
  const ChangePasswordProps: ChangePasswordProps = {
    ...passThroughProps,

  };
  return (
    <>
    {getHeader()}
    <table>
      <tbody>
        {/* username section */}
        {(passThroughProps.isDomainFamilyAD || passThroughProps.isViewerServerAdmin || passThroughProps.isViewerSelf) &&
          <tr>
            <td  className={EmailAndDisplayNameForm.getBodyStyle()} colSpan={3}>
                <table>
                  <tbody>
                    <tr id="settings-username">
                      <td className={EmailAndDisplayNameForm.getLabelStyle()}>{Messages.username()}</td>
                      <td className="tb-details-value" tb-test-id="tb-username-value-id">{passThroughProps.serverUser.username}</td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
            </td>
          </tr>
        }
        <tr>
          <td  className={EmailAndDisplayNameForm.getBodyStyle()} colSpan={3}>
            <EmailAndDisplayNameForm.Form {...emailAndDisplayNameFormProps}/>
          </td>
        </tr>
        {FeatureFlags.userSettingMigration &&
          <ChangePassword {...ChangePasswordProps}/>
        }
      </tbody>
    </table>
    </>
  );
}